import { useSearchParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
/**
 *
 * @param {string} key
 * @param {{}} savedServiceParams
 */
export const useSaveServiceParams = (key, savedServiceParams = {}) => {
  const [searchParams] = useSearchParams();
  const addServiceParams = useBoundStore((state) => state[key].addServiceParams);
  let allParams = savedServiceParams;

  if (Object.keys(allParams).length < 1) {
    for (const [k, v] of searchParams.entries()) {
      allParams = { ...allParams, [k]: v };
    }
    addServiceParams(allParams);
  }

  return allParams;
};
